<template>
  <div class="actions">
    <button class="btn btn-sm btn-outline-success btn-block"
            type="button"
            @click="itemAction('edit-item', rowData, rowIndex)">
      <i class="fas fa-edit mr-1"></i> Edit
    </button>
    <button class="btn btn-sm btn-outline-danger  btn-block"
            type="button"
            @click="itemAction('delete-item', rowData, rowIndex)">
      <i class="far fa-trash-alt mr-1"></i> Delete
    </button>
    <button class="btn btn-sm btn-block"
            :class="rowData.startSchedule !== '' && rowData.endSchedule !== '' ?
              'btn-outline-secondary' : 'btn-outline-primary'"
            @click="itemAction('send-item', rowData, rowIndex)"
            v-if="rowData.status === 'Unsent'"
            type="button"
            :disabled="rowData.startSchedule !== '' &&
              rowData.endSchedule !== ''">
      <i class="far fa-bell mr-1"></i> Send
    </button>
    <button class="btn btn-sm btn-primary btn-block"
            type="button"
            v-if="rowData.status === 'Sent'">
      <i class="far fa-bell mr-1"></i> Sent
    </button>
  </div>
</template>

<script>
  const EditAnnouncement = () => import('./EditAnnouncement.vue');
  const SendAnnouncement = () => import('./SendAnnouncement.vue');

  export default {
    name  : 'AnnouncementListActions',
    props : {
      rowData : {
        type     : Object,
        required : true,
      },
      rowIndex : {
        type : Number,
      },
    },
    methods : {
      itemAction(action, data, index) {
        if (action === 'edit-item') {
          this.$modal.show(EditAnnouncement, {
            data : data,
          }, {
            height   : 'auto',
            adaptive : true,
          }, {
            'reload-table' : (event) => {
              this.$parent.reload();
            },
          });
        } else if (action === 'delete-item') {
          this.$modal.show('dialog', {
            title   : 'Please confirm:',
            text    : `Are you sure you want to delete <b>${data.title}</b>?`,
            buttons : [ {
              title   : 'Yes',
              handler : () => {
                this.$events.fire('loading-state', true);
                this.$http.delete('api/announcement', {
                  data : {
                    'announcementId' : data.announcementId,
                  },
                }).then(() => {
                  this.$events.fire('loading-state', false);
                  this.$events.fire('reload');
                  this.$parent.reload();
                  this.$modal.hide('dialog');
                  this.$notify({
                    group : 'notif',
                    type  : 'success',
                    title : 'Success!',
                    text  : 'Deleted announcement successfully.',
                  });
                }).catch(() => {
                  this.$events.fire('loading-state', false);
                  this.$notify({
                    group : 'notif',
                    type  : 'error',
                    title : 'Failed',
                    text  : 'Oops! Something went wrong!',
                  });
                });
              },
            }, {
              title : 'No',
            } ],
          });
        } else if (action === 'send-item') {
          this.$modal.show(SendAnnouncement, {
            data : data,
          }, {
            height   : 'auto',
            adaptive : true,
          }, {
            'reload-table' : (event) => {
              this.$parent.reload();
            },
          });
        }
      },
    },
  }
</script>

<style lang="scss">
@import
  "../../../assets/scss/components/admin/announcement/announcement-list-actions"
</style>